import React, { useEffect, useState } from 'react';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';

import { PendingNotificationsSidebar } from '../../notification';
import { useNotificationContext } from '../contexts/NotificationContext';

export const PendingNotificationPreviewButton = () => {
  const { loadNotifications } = useNotificationContext();
  const [drawerNotification, setDrawerNotification] = useState(false);

  useEffect(() => {
    loadNotifications();
  }, []);

  return (
    <div>
      <button className="btn p-0" onClick={() => setDrawerNotification(true)}>
        <NotificationsActiveOutlinedIcon fontSize="large" className="text-primary" />
        {/* Badge eliminado: los popups se muestran automáticamente */}
      </button>
      <PendingNotificationsSidebar open={drawerNotification} close={() => setDrawerNotification(false)} />
    </div>
  );
};